<template>
  <div dir="rtl">
    <vue-modaltor
      :visible="openModal"
      @hide="hideModal"
      :default-width="'30%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width='{1200:"60%",992:"80%",768:"90%"}'
    >
      <app-loading :isFull="false" v-if="isLoading"/>
      <div class="row pt-2">
        <div class="col-12">
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              name="en_tag"
              :class="{active:en_tag != '' }"
              v-model="en_tag"
            >
            <span class="bar"></span>
            <label>نام تگ به انگلیسی</label>
            <span v-if="errors.has('en_tag')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-6">
          <button
            class="mt-3 bttn-fill bttn bttn-primary font-14"
            @click="saveNewTag"
            v-ripple
          >ساخت تگ جدید</button>
        </div>
      </div>
    </vue-modaltor>
    <label class="typo__label">مدیریت تگ ها</label>
    <multiselect
      @input="updateValueAction"
      v-model="value"
      tag-placeholder="تگ جدید اضافه کنید"
      placeholder="تگ را جستجو و یا اضافه کنید"
      label="tag"
      track-by="id"
      :options="options"
      selectLabel="برای انتخاب تگ کلیک کنید"
      selectedLabel="انتخاب شده"
      deselectLabel="برای حذف تگ کلیک کنید"
      :hideSelected="true"
      :multiple="true"
      :taggable="true"
      @tag="addTag"
    >
      <span slot="noResult">مورد مشابه یافت نشد و یا قبلا اضافه شده</span>
    </multiselect>
  </div>
</template>

<script>
export default {
  name: "tag-list",
  // props: {
  //   options: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  created() {
    this.$store.dispatch("dashboardTag/getTags");
  },
  computed: {
    options() {
      return this.$store.state.dashboardTag.tags;
    },
    value: {
      get() {
        return this.$store.state.dashboardTag.tagCourses;
      },
      set(newValue) {}
    }
    // value () {
    //   return this.$store.state.dashboardTag.tagCourses
    // }
  },

  data() {
    return {
      tag: "",
      en_tag: "",
      openModal: false,
      isLoading: false
    };
  },
  methods: {
    hideModal() {
      this.openModal = false;
    },
    updateValueAction(item) {
      this.$store.commit("dashboardTag/updateValue", item);
    },
    removeTag(item) {
      var vals = [...this.tagCourses];
      var index = vals.findIndex(e => e.id === item.id);
      this.$store.commit("dashboardTag/removeTagCourses", index);
    },
    async saveNewTag() {
      this.isLoading = true;
      let { data } = await axios.post("/tags/new", {
        tag: this.tag,
        en_tag: this.en_tag
      });
      this.isLoading = false;
      this.hideModal();
      if (data.state != 200) return;
      const tag = {
        tag: this.tag,
        id: data.tag_id
      };

      this.options.push(tag);
      //   this.value.push(tag)
      this.$store.commit("dashboardTag/addTagCourse", tag); // addTags (state, tags)
      this.tag = "";
      this.en_tag = "";
    },
    async addTag(newTag) {
      this.openModal = true;
      this.tag = newTag;
    }
  }
};
</script>

<style lang="less">
.typo__label {
  text-align: right;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/tag-list.vue